import gql from 'graphql-tag'

export default gql`
query searchBib($bib: String!) {
  labels(
    sort: _ID_DESC
    filter: { data: { bibs: $bib } } 
  ) {
    _id
    referenceId
    seq
    last
    data
    recipient
    address
    app
    group
    tracking {
      _id
      carrier
      code
      sendHook
      scannedAt
      status
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/searchBib.js